<template>
  <!-- 套餐详情 - start -->
  <div class="group-info">
    <slot name="title">
    </slot>
    <td
      class="icon-group icon-group-show"
      v-show="!isShowGroup"
      @click="isShowGroup = !isShowGroup"
    />
    <td
      class="icon-group icon-group-hide"
      v-show="isShowGroup"
      @click="isShowGroup = !isShowGroup"
    />
    <slot></slot>
    <div :class="['group-detail-box', { 'group-detail-order': product.groups }]">
      <div class="group-detail" v-show="isShowGroup">
        <template v-if="product.groups">
          <span>{{ product.name }}</span>
          <template v-for="(group, groupIndex) in product.groups.slice(0, 1)">
            <template v-for="main in group.mains">
              <template v-for="(mainGroup, mainGroupIndex) in main.groups">
                <template v-for="(products, index) in mainGroup.products">
                  <div class="group-item clearfix" :key="`${mainGroupIndex}${groupIndex}products${index}`">
                    <div class="item-name">
                      <span>{{ products.name }}</span>
                    </div>
                    <div class="item-num">{{ products.num }}</div>
                  </div>
                </template>
              </template>
            </template>
            <div class="exArea" v-if="group.exArea && group.exArea.groups" :key="'group' + groupIndex">
              <template v-for="(exAreaGroup, exAreaGroupIndex) in group.exArea.groups">
                <template v-for="(products, exGindex) in exAreaGroup.products">
                  <div class="group-item clearfix" :key="`${exAreaGroupIndex}group-item${exGindex}`">
                    <div class="item-name">
                      <span>{{ products.name }}</span>
                    </div>
                    <div class="item-num">{{ products.num }}</div>
                  </div>
                </template>
              </template>
            </div>
          </template>
        </template>
        <template v-else>
          <div v-for="(item, ii) in product" :key="ii + 'item'" class="group-item clearfix">
            <div class="item-name">
              <span>{{ item.name }}</span>
              <template v-if="item.listPropertys.length > 0">
                <template v-for="(property, $index) in item.listPropertys">
                  <span :key="`property${$index}`" v-if="$index==0">(</span>
                  <span v-for="(prop, index) in property.propertys" :key="index + 'prop'">
                    <em class="normal">
                      {{ prop.name + (index === property.propertys.length - 1  ? '' : ',') }}
                    </em>
                  </span>
                  <span :key="`listPropertys${$index}`" v-if="$index === item.listPropertys.length-1">
                    )
                  </span>
                  <span :key="`fu${$index}`" v-else>,</span>
                </template>
              </template>
            </div>
            <div class="item-num">{{ item.num }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'group-info',
  props: {
    product: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      isShowGroup: false,
    };
  },
};
</script>

<style lang="sass" scoped>
  .icon-group
    margin-left: 5px
    cursor: pointer
    width: 10px
    height: 12px
    background-position: center
    &-hide
      background-repeat: no-repeat
      background-image: url('../../assets/image/icon/icon-group-hide.png')
    &-show
      background-repeat: no-repeat
      background-image: url('../../assets/image/icon/icon-group-show.png')
  .group-detail-box,
  .reply-list-box
    margin-top: 10px
    overflow-y: auto
    padding-right: 10px
    background-color: #fff
    &.group-detail-order
      background-color: inherit
    h3
      text-align: right
      .close
        display: inline-block
        width: 21px
        height: 21px
        font-size: 21px
        font-weight: 700
        line-height: 1
        color: #fc8b00
        text-shadow: 0 1px 0 #fff
        text-align: right
        margin: 8px 0 18px 0
        font-style: normal
        cursor: pointer
  .group-detail
    >span
      font-size: 14px
    .exArea
      border-top: 1px solid #cacaca
    h4
      color: #494949
      font-size: 14px
      line-height: 28px
      margin-top: 18px
      &:first-child
        margin-top: 0px
    .group-item
      line-height: 28px
      color: #5b5b5b
      text-align: left
      .item-name
        display: inline-block
        width: 130px
        height: 100%
      .item-num
        display: inline-block
        width: 82px
        text-align: center
        height: 100%
      .normal
        font-style: normal
</style>
